import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { analysesApi } from "@/lib/api";
import KpiCard from "@/components/KpiCard";
import { SectorRadar, EspaceSocialArea } from "@/components/charts/Charts";

export default function MacroAnalysis() {
  const { projectId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    analysesApi.summary(projectId).then(setData);
  }, [projectId]);

  if (!data) return <div className="p-10 label-mono text-xs text-muted-foreground">Chargement…</div>;
  const v = data.macro.viabilite || {};
  const m = data.macro.macro_snapshot || {};
  const d = data.macro.debt_snapshot || {};

  return (
    <div className="px-6 lg:px-10 py-8 max-w-7xl mx-auto w-full" data-testid="macro-page">
      <div className="label-mono text-[10px] text-muted-foreground">MODULE 2.1</div>
      <h1 className="mt-1 font-serif font-bold text-4xl">Analyse macro-financière</h1>

      <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
        <KpiCard label="DETTE / PIB" value={v.debt_gdp_ratio} unit="%" band={v.debt_gdp_band} format="pct" />
        <KpiCard label="SERVICE / PIB" value={v.service_gdp_ratio} unit="%" format="pct" />
        <KpiCard label="SERVICE / RECETTES" value={v.service_revenue_ratio} unit="%" band={v.service_revenue_band} format="pct" />
        <KpiCard label="TAUX EFFECTIF" value={v.effective_rate} unit="%" format="pct" />
      </div>

      <div className="mt-8 grid md:grid-cols-2 gap-6">
        <div className="border border-border bg-card rounded-sm p-5">
          <h3 className="font-serif font-bold">Snapshot macro</h3>
          <table className="mt-3 w-full text-xs">
            <tbody>
              {Object.entries(m).map(([k, val]) => (
                <tr key={k} className="border-t border-border">
                  <td className="py-1.5 text-muted-foreground">{k}</td>
                  <td className="py-1.5 text-right font-mono">{val == null ? "—" : Number(val).toLocaleString("fr-FR")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="border border-border bg-card rounded-sm p-5">
          <h3 className="font-serif font-bold">Snapshot dette</h3>
          <table className="mt-3 w-full text-xs">
            <tbody>
              {Object.entries(d).map(([k, val]) => (
                <tr key={k} className="border-t border-border">
                  <td className="py-1.5 text-muted-foreground">{k}</td>
                  <td className="py-1.5 text-right font-mono">{val == null ? "—" : Number(val).toLocaleString("fr-FR")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-8 grid md:grid-cols-2 gap-6">
        <div className="border border-border bg-card rounded-sm p-5">
          <h3 className="font-serif font-bold">Espace budgétaire social — 5 ans</h3>
          <EspaceSocialArea macro={m} debt={d} vit={data.vitaliste} />
        </div>
        <div className="border border-border bg-card rounded-sm p-5">
          <h3 className="font-serif font-bold">Performance sectorielle sociale</h3>
          <SectorRadar social={data.aggregated?.social_indicators || {}} />
        </div>
      </div>
    </div>
  );
}
